import { doc, getFirestore, getDoc, updateDoc } from 'firebase/firestore';
import React, { useEffect, useRef, useState } from 'react';
import { app } from '../firebase'; // Importez votre configuration Firebase
import { fetchDoc, isProvider, useUser, isRentalManager, isCoownership } from '../contexts/UserContext';
import Loader from '../components/Loader';
import { useNavigate } from 'react-router-dom';
import {Icon} from 'react-icons-kit';
import {trash} from 'react-icons-kit/feather/trash';
import DeleteModal from '../components/modals/DeleteModal';
import CustomCalendarProvider from '../calendar/CustomCalendarProvider';
import PrimaryButton from '../components/buttons/PrimaryButton';
import AddCoownershipAccount from './AddCoownershipAccount';
import useDeleteUserFromCoownership from './hooks/useDeleteUserFromCoownership';

const db = getFirestore(app);

function ChooseCoownership() {

  let user = useUser(); 

  const [coownerships, setCoownerships] = useState([]);
  const [filteredCoownerships, setFilteredCoownerships] = useState([]);
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [showDeleteModal, setShowDeleteModal] = useState(false); 
  const [coownershipToDelete, setCoownershipToDelete] = useState(null);
  const [showAddCoownership, setShowAddCoownership] = useState(false);
  const { deleteProviderFromCoownership, deleteCoownershipFromSyndic, deleteRentalManagerFromCoownership } = useDeleteUserFromCoownership(); 
  const deactivatedAlertShown = useRef(false);


  useEffect(() => {
    if (
      user.user?.userData?.isLastCoownershipDeactivated &&
      !deactivatedAlertShown.current
    ) {
      deactivatedAlertShown.current = true;
      alert("Cette copropriété n'est plus active. Choisissez-en une autre, supprimez-la, ou ajoutez-en une nouvelle.");
    }
  }, [user.user?.userData?.isLastCoownershipDeactivated]);

  useEffect(() => {
    //on boucle sur l'ensemble des coownership de l'utilisateur 
    user.user.userData.coownershipId.map((coownership) => {
      //on execute la query pour récupérer les infos de la coownership 
      getCoownership(coownership.coownershipReference.path); 
    })
  }, []); 

  useEffect(() => {
    // Trier les copropriétés par ordre alphabétique
    const sortedCoownerships = [...coownerships].sort((a, b) => 
      a.name.localeCompare(b.name, 'fr', { sensitivity: 'base' })
    );
    setFilteredCoownerships(sortedCoownerships);
  }, [coownerships]);

  useEffect(() => {
    const coownershipsArray = coownerships.filter((coownership) =>
      coownership.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    // Trier les résultats de recherche par ordre alphabétique
    const sortedCoownershipsArray = coownershipsArray.sort((a, b) => 
      a.name.localeCompare(b.name, 'fr', { sensitivity: 'base' })
    );

    setFilteredCoownerships(sortedCoownershipsArray);
  }, [searchTerm]); 


  const getCoownership = async (coownershipPath) => {
    
    const docRef = doc(db, coownershipPath);

    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {

      let obj = {
        id: docSnap.id, 
        address: docSnap.data().address,
        zip: docSnap.data().zip,
        city: docSnap.data().city,
        image: docSnap.data().image, 
        name: docSnap.data().name,
        mailSyndic: docSnap.data().mailSyndic,
        status: docSnap.data().status,
      }
  
      setCoownerships(coownerships => [...coownerships, obj]);
    }
  }


  const updateLastCoownership = async (coownership) => {
    if (coownership.status !== "activated") {
      alert("Cette copropriété est désactivée. Vous ne pouvez pas la sélectionner.");
      return;
    }

    const coownershipId = coownership.id;
    const docRefCoownership = doc(db, "coownership/"+coownershipId); //on créé la référence qui sera update dans le champs lastCoownershipLoaded

    //on envoie les données sur firestore 
    const userDoc = doc(db, "users/"+user.user.user.uid);

    await updateDoc(userDoc, {
      lastCoownershipLoaded: docRefCoownership,
    });

    let userData = user.user.userData; 

    userData.lastCoownershipLoaded = docRefCoownership; 
    userData.isLastCoownershipDeactivated = false;


    let coownershipData = await fetchDoc(docRefCoownership); 

    if(coownershipData.name){              
      userData.nameCoownershipLoaded = coownershipData.name; 
      userData.codeOwner = coownershipData.codeOwner;
      userData.rentalManagerCreateContent = coownershipData.rentalManagerCreateContent ?? false;
    }

    //on update le contexte de l'utilisateur 
    user.setUser({user: user.user.user, userData: userData});

    navigate('/dashboard'); // Redirigez l'utilisateur vers la home
  } 

  const deleteCoownership = async () => {
    if(isProvider(user.user)){ //prestataire
      await deleteProviderFromCoownership(user.user.user.uid, "coownership/"+coownershipToDelete);
    }else if(isCoownership(user.user)){ //syndic
      await deleteCoownershipFromSyndic(user.user.user.uid, "coownership/"+coownershipToDelete);
    }else if(isRentalManager(user.user)){ //gestionnaire locatif
      await deleteRentalManagerFromCoownership(user.user.user.uid, "coownership/"+coownershipToDelete);
    }
  }


  /**
   * un item de la liste
   * @param {*} param0 
   * @returns 
   */
  function ListItem(coownership) {
    const isDeactivated = coownership.status !== "activated";

    return (
      <div
        className={`flex items-center p-2 border-b border-gray-300 cursor-pointer ${isDeactivated ? "opacity-70" : ""}`}
        onClick={() => updateLastCoownership(coownership)}
      >
        <span className="text-red-500 cursor-pointer" onClick={(e) => {e.stopPropagation(); setCoownershipToDelete(coownership.id); setShowDeleteModal(true)}}>
          <Icon className='mr-4' icon={trash} size={20} />
        </span>
        <div className="w-12 h-12 rounded-full overflow-hidden mr-4 border-1 border-primary">
          <img src={coownership.image ? coownership.image : "https://firebasestorage.googleapis.com/v0/b/trustymo-72f96.appspot.com/o/coownershipPicture%2Fbernard-hermant-KqOLr8OiQLU-unsplash.jpg?alt=media&token=620baa2d-727f-4e07-b2f0-396dce037390"} alt={coownership.name} className="w-full h-full" />
        </div>
        <div className='flex-grow'>
          <div className="flex items-center gap-2">
            <div className="text-primary text-lg">{coownership.name}</div>
            {isDeactivated ? (
              <span className="text-xs font-medium text-red-600 bg-red-50 px-2 py-0.5 rounded">
                Désactivée
              </span>
            ) : null}
          </div>
          <div className="text-sm">{coownership.mailSyndic}</div>
          <div className="text-sm">{coownership.address + " " + (coownership.zip ? coownership.zip : "") + " " + (coownership.city ? coownership.city : "")}</div>
        </div>
        
        {user.user.userData?.lastCoownershipLoaded?.path == "coownership/"+coownership.id ? (
          <div className="text-secondary text-2xl">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-8 w-8"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
        ) : null }
      </div>
    );
  }

  return (
    <div className='min-h-screen flex flex-col justify-center items-center '>
      <div className=' md:w-5/6 md:h-5/6 p-8 justify-center'>
        {isProvider(user.user) && user.user?.userData?.lastCoownershipLoaded != null && (
           <CustomCalendarProvider listCoownership={coownerships}/>
        )}

        {(isProvider(user.user) || isRentalManager(user.user)) && (
          <a href="#" onClick={() => setShowAddCoownership(true)} className="justify-start flex mb-4 mt-8">
            <PrimaryButton type={"button"} value={"Ajouter une copropriété"} loading={false} />
          </a>
        )}

        <input
          type="text"
          placeholder="Rechercher..."
          value={searchTerm}
          onChange={(event) => setSearchTerm(event.target.value)}
          className="p-2 border rounded-xl w-full focus:border-primary"
        />
        {filteredCoownerships.length > 0 ? (
          filteredCoownerships.map((coownership, key) => {
            return(
              <div>
                {ListItem(coownership)}
              </div>
            )
          })
        ) : (
          <Loader />
        )}
      </div>
      {showDeleteModal ? (
        <DeleteModal closeAction={() => setShowDeleteModal(false)} type={"delete"}
          confirmAction={async () => {
            await deleteCoownership(); 
            window.location.reload();
          }} />
      ) : null }

      {showAddCoownership ? (
        <AddCoownershipAccount closeAction={() => setShowAddCoownership(false)}/>
      ) : null }
    </div> 
  );
}

export default ChooseCoownership;